export interface SettingsInterface {
  waitingTime: number;
  additionalSubjectsDuration: number;
  notificationDuration: number;
  darkMode: boolean;
  screenSaver: ScreenSaver;
  weather: WeatherData;
}

export class WeatherData {
  isActive: boolean;
  location: string;
}

export class ScreenSaver {
  isActive: boolean;
  duration: number;
  clockType: string;
}

export class Settings implements SettingsInterface {
  darkMode = false;
  waitingTime = 15;
  additionalSubjectsDuration = 30;
  notificationDuration = 10;
  screenSaver = new ScreenSaver();
  weather = new WeatherData();
}

export class AppSettings {
  public static defaultImage = "./assets/img/icon.png";
}

export interface ResourceObject {
  address: {
    city: string;
    countryOrRegion: string;
    postalCode: string;
    state: string;
    street: string;
  };
  addOns: Array<any>;
  language: string;
  devices: Array<any>;
  displayName: string;
  licenseNumber: string;
  organizationId: string;
  resourceAccount: string;
  settings: SettingsInterface;
  buttons: Array<DoorBellButton>;
  _id: string;
  _t: string;
}
export interface DoorBellButton {
  _id: string;
  buttonName: string;
  team: string;
  channel: ChannelData;
  activateEmployeePIN: boolean;
  activatePhoto: boolean;
  activatePhotoPrivacyPolicy: boolean;
  employeePIN: string;
  employeePINSalt: string;
  lockURL: string;
  lockKey: string;
  subjects: DoorBellData[];
  successMessage: DoorBellText;
  waitingMessage: DoorBellText;
  failedMessage: DoorBellText;
  infoMessage: DoorBellText;
  rejectedCallingMessage: DoorBellText;
  endCallingMessage: DoorBellText;
  privacyPolicy: DoorBellText;
  enableChat: boolean;
  enableCalling: boolean;
  enableConcern: boolean;
  callConnector: string;
  callType: string;
  recipientId: string;
  defaultPostMessage: string;
  chatConnectorId: string;
}

export interface CallModalButton {
  _id: string;
  buttonName: string;
  rejectedCallingMessage: DoorBellText;
  endCallingMessage: DoorBellText;
  callConnector: string;
  callType: string;
  recipientId: string;
  triggerAutomation: () => Promise<void>;
}

export class DoorBellData {
  _id: string;
  title: DoorBellText;
  message: DoorBellText;
}

export interface DoorBellMessages {
  successMessage: DoorBellText;
  waitingMessage: DoorBellText;
  failedMessage: DoorBellText;
  infoMessage: DoorBellText;
  privacyPolicy: DoorBellText;
}

export class DoorBellText {
  en: string = "";
  de: string = "";
}
export class ChannelData {
  id: string = "";
  displayname: string = "";
}
export interface iMessageResp {
  id?: string;
  etag?: string;
}
